import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-small-device-alert',
    templateUrl: './small-device-alert.component.html',
    styleUrls: ['./small-device-alert.component.scss'],
    standalone: false
})
export class SmallDeviceAlertComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
